import Submissions from './components/Submissions'
import Users from './components/Users'
import FrontendUsers from './components/FrontendUsers'
import AdminParent from './components/AdminParent'
import Login from '../auth/components/Login';

export default [
    {
        path: '/formadmin',
        name: 'Admin',
        component: AdminParent,
        meta: {auth: 'admin'},
        iconCls: 'el-icon-menu',
        children: [
            {
                path: '',
                name: 'Submissions',
                component: Submissions,
                iconCls: 'el-icon-postcard'
            },
            {
                path: 'users',
                name: 'Admin Users',
                component: Users,
                iconCls: 'el-icon-user'
            },
            {
                path: 'frontent-users',
                name: 'Frontend Users',
                component: FrontendUsers,
                iconCls: 'el-icon-user'
            },
            {
                path: 'login',
                component: Login,
                name: 'admin-login',
                props: {loginRedirect: 'Submissions'},
                hidden: true,
                meta: {
                    auth: false,
                },
            }
        ],
    }
]
